<div class="container admin" >

     <div class="row">
            <div class="col-12">
                <div class="manage-user-header">
                    <div class="search">
                        <mat-form-field>
                            <mat-label>{{'search' | translate}}</mat-label>
                            <input matInput type="text" (keyup)="doFilter($event)">
                        </mat-form-field>
                    </div>
                    <div class="right">
                        <button (click)="newUser()" mat-raised-button><mat-icon fontIcon="add"></mat-icon>{{'newUser' | translate}}</button>
                    </div>
                </div>
            </div>
        </div>
    <div class="row">
        <div class="col-12">

        </div>
    </div>

    <div class="user-wrapper" appFullHigh>
        <div class="row">
            <div class="col-12">
                <div class="user-table-wrapper">
                    <table mat-table [dataSource]="dataSource" class="user-table" matSort>
                        <ng-container matColumnDef = "firstName">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header>Firstname</th>
                            <td mat-cell *matCellDef="let user">{{user.firstName}}</td>
                        </ng-container>
                        <ng-container matColumnDef = "lastName">
                            <th mat-header-cell *matHeaderCellDef  mat-sort-header>Lastname</th>
                            <td mat-cell *matCellDef="let user">{{user.lastName}}</td>
                        </ng-container>

                        <ng-container matColumnDef = "email">
                            <th mat-header-cell *matHeaderCellDef  mat-sort-header>Email</th>
                            <td mat-cell *matCellDef="let user">{{user.email}}</td>
                        </ng-container>
                        <ng-container matColumnDef = "roles">
                            <th mat-header-cell *matHeaderCellDef  mat-sort-header>Roles</th>
                            <td mat-cell *matCellDef="let user">
                                @for(role of user.roles; track role) {
                                    <span>{{role.description}}</span><br>
                                }
                            </td>
                        </ng-container>
                        <ng-container matColumnDef = "createdAt">
                            <th mat-header-cell *matHeaderCellDef  mat-sort-header>Created at</th>
                            <td mat-cell *matCellDef="let user">{{user.createdAt|dateLocale}}</td>
                        </ng-container>
                        <ng-container matColumnDef = "updatedAt">
                            <th mat-header-cell *matHeaderCellDef  mat-sort-header>Updated at</th>
                            <td mat-cell *matCellDef="let user">{{user.updatedAt|dateLocale}}</td>
                        </ng-container>
                        <ng-container matColumnDef = "icons">
                            <th class="icons" mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let user">
                            <span class="icon-wrapper">
                                <span  (click)="editUser(user, false)"><mat-icon fontIcon="edit"></mat-icon></span>
                                <span  (click)="editUser(user, true)"><mat-icon fontIcon="content_copy"></mat-icon></span>
                                @if(user.isActive) {
                                    <span  (click)="loginAs(user)"><mat-icon fontIcon="face_right"></mat-icon></span>
                                }
                            </span>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>

                <mat-paginator [pageSizeOptions]="[10, 20, 40]"
                               showFirstLastButtons
                               aria-label="Select page forms">
                </mat-paginator>
            </div>
        </div>
    </div>


</div>
